import { combineReducers } from 'redux';
import authReducer from './authReducer';
import ledmoduleReducer from './ledmoduleReducer';
import ledmodulesReducer from './ledmodulesReducer';
import errorsReducer from './errorsReducer';

export default combineReducers({
    auth: authReducer,
    ledmodules: ledmodulesReducer,
    ledmodule: ledmoduleReducer,
    errorsHandler: errorsReducer
});